//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { OpChangeState, Enums } from "../common/enums"

import { Dictionary, DataProvider, CommonHelper } from "../../helpers"

import { OpDataList, ObjectCustomString } from "../util"
import { IOpObject, IOpData, IReferenceType } from "../util/interfaces"

import { OpOperatorGroupData, OpOperator, OpDataType } from "."
import { OpTechnicalPermission } from "./op-technical-permission"

export class OpOperatorGroup implements IOpObject, IReferenceType {

    // #region Properties

    public idOperatorGroup: number
    public name: string
    public idDescr: number
    public idDistributor: number
    public isEnabled: boolean

    // #endregion


    // #region Custom Properties

    public currentOperators: OpOperator[] = []
    public technicalPermissions: OpTechnicalPermission[] = []

    // #endregion


    // #region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #endregion


    // #region IOpChangeState Implementation

    public opState: OpChangeState

    // #endregion


    // #region IReferenceType Implementation

    public getReferenceKey(): number {
        return this.idOperatorGroup
    }

    public getReferenceValue(): any {
        return this
    }

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdOperatorGroup
    }

    // #endregion


    // #region IOpObject Implementation

    public dataList: OpDataList<OpOperatorGroupData> = new OpDataList<OpOperatorGroupData>()

    public dynamicValues: { Key: string, Value: any }[]

    public customFormatString: string

    public get idObject(): any {
        return this.idOperatorGroup
    }
    public set idObject(idObject: any) {
        this.idOperatorGroup = idObject
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_OPERATOR_GROUP: this.idOperatorGroup,
            NAME: this.name,
            ID_DESCR: this.idDescr,
            ID_DISTRIBUTOR: this.idDistributor,
            IS_ENABLED: this.isEnabled,
            dynamicValues: this.dynamicValues,
            DataList: this.dataList != null ? this.dataList.ToJSON() : null,
            OpState: this.opState,
            CurrentOperators: this.currentOperators != null ? this.currentOperators.map((operator: OpOperator) => { return operator.toJSON() }) : null,
            TechnicalPermissions: this.technicalPermissions != null ? this.technicalPermissions.map((technicalPermission: OpTechnicalPermission) => { return technicalPermission.toJSON(compressed) }) : null
        }
    }

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idOperatorGroup = opObj.ID_OPERATOR_GROUP
            this.name = opObj.NAME
            this.idDescr = opObj.ID_DESCR
            this.idDistributor = opObj.ID_DISTRIBUTOR
            this.isEnabled = opObj.IS_ENABLED
            this.dynamicValues = opObj.dynamicValues
            this.opState = opObj.OpState
            this.customFormatString = opObj.CustomFormatString

            if (opObj.DataList != null) {
                this.dataList.push(...opObj.DataList.map((data: any) => new OpOperatorGroupData(data)))
            }
            if (opObj.CurrentOperators != null) {
                this.currentOperators.push(...opObj.CurrentOperators.map((operator: any) => new OpOperator(operator)))
            }
            if (opObj.TechnicalPermissions != null) {
                this.technicalPermissions.push(...opObj.TechnicalPermissions.map((permission: any) => new OpTechnicalPermission(permission)))
            }
        }
    }

    public toString(): string {
        const customFormatString: string = ObjectCustomString.getCustomStringFormat(this)

        if (!customFormatString) {
            return this.name
        }

        return ObjectCustomString.getObjectCustomString(customFormatString, this)
    }

    // #endregion

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpOperatorGroup[]): JQueryPromise<OpOperatorGroup[]> {
        const defered = $.Deferred<OpOperatorGroup[]>()

        if (dataProvider && list && list.length > 0) {
            const idDataType: number[] = CommonHelper.getIdDataTypesFromObjectList<OpOperatorGroup>(list)
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType]).then(dict => {
                let dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                }

                list.forEach((item: OpOperatorGroup) => {
                    if (item.dataList) {
                        item.dataList
                            .toArray()
                            .forEach((data: OpOperatorGroupData) => {
                                data.dataType = dataTypeDict.tryGetValue(data.idDataType)
                            })
                    }
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }

    public static fromIOpObject(object: IOpObject): OpOperatorGroup {
        const newObject: OpOperatorGroup = new OpOperatorGroup(null)
        newObject.idOperatorGroup = object.idObject
        newObject.opState = object.opState
        newObject.dataList.push(...object.dataList.toArray().map((data: IOpData) => OpOperatorGroupData.fromIOpData(data)))

        return newObject
    }

}